import { post, get } from './api';

export function getSurvey() {
    return get('survey/findSurvey')
        .then((res) => {
            return res;
        })
        .catch((error) => {
            return Promise.reject(error);
        });
}

export function createResult(result) {
    return post('survey/createResult/' + result).catch((res) => {
        return Promise.reject(res);
    });
}


// WEBPACK FOOTER //
// ./src/services/api/survey.js